import React, { useState, useEffect } from "react";
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Table, Button, Container, Modal, Form, ButtonGroup, Pagination, Spinner } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';
import ErrorModal from './ErrorModal';


const BoardStatus = () => {
  const [statuses, setStatus] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [deleteState, setDeleteState] = useState(false);
  const [errors, setErrors] = useState({}); // Error state
  const [apierrors, setApiErrors] = useState('');// Error state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filterTerm, setFilterTerm] = useState('');

  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(' Lade, bitte warten...');
  const [showModal, setShowModal] = useState(false);
  const [errorCode, setApiErrorCode] = useState('');// Error state


  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); // Set items per page


  

  const [formData, setFormData] = useState({
    status_name: "",
    
  });

  const validateForm = () => {
    console.log("formData:", formData);
    const newErrors = {};
    if (!formData?.status_name?.trim()) {
        newErrors.status_name = "Status Name is required";
    }
    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
};

  


  useEffect(() => {
    
    UserService.getStatusBoard().then(
      (response) => {
        setStatus(response.data);
       
      }).catch((error) => {
        console.log(error);
        console.log(error.message);
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          console.log(_content);
          if (error.response) {
            // Server responded with a status other than 200 range
            setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else if (error.request) {
            // Request was made, but no response was received
            setApiErrors('Error: No response received from the server.');
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else {
            // Other types of errors
            setApiErrors(`Error: ${error.response.data.message}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } 
        setStatus(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
        
      
});
  }, [deleteState]);
  
 
  


// Filter the mainvos based on the filter input
const filteredMainVOs = Array.isArray(statuses)
    ? statuses.filter((vo) =>
        (vo.status_name && vo.status_name.toLowerCase().includes(filterTerm.toLowerCase())) ||
        (vo.rec_date && vo.rec_date.includes(filterTerm))
      )
    : [];

  
// Get the current page's data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentMainVOs = filteredMainVOs.slice(indexOfFirstItem, indexOfLastItem);
 
   // Handle pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Sorting function
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };
  

  // Sort the filtered data
  const sortedMainVOs = [...filteredMainVOs].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });


  // Total pages calculation
  const totalPages = Math.ceil(filteredMainVOs.length / itemsPerPage);

  const handleEditClick = (main_vo) => {
    setApiErrors(null);
    setApiErrorCode(null);
    setSelectedStatus(main_vo);
    setFormData(main_vo);
    setShowEditModal(true);
  };

  const handleCreateClick = () => {
    setFormData({});
    setShowCreateModal(true);
    setApiErrors(null);
    setApiErrorCode(null);
  };


  const isValidDate = (date) => {
    return !isNaN(Date.parse(date));
  };

  const handleDeleteClick = async (id,e) => {
    e.preventDefault();
    setApiErrors(null);
    setApiErrorCode(null);
    try { 
      setLoadingText('Daten werden gelöscht, bitte warten...');
      setLoading(true);
      await UserService.deleteStatusBoard(id);
      setDeleteState(prev => !prev);
      console.info(deleteState);
    } catch (error) {
      setApiErrors(`Error: ${error.name}-${error.code} - ${error.response.data.message}-${error.response.data.error}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      setShowModal(true);
      console.error('Error deleting Status Object:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    console.log(selectedStatus);
    if (!validateForm()) return; 
    try {
      setLoadingText('Daten werden aktualisiert, bitte warten...');
      setLoading(true);
      // formData.rec_date = new Date();
      await UserService.updateStatusBoard(selectedStatus.status_id,formData);
      setDeleteState(prev => !prev);
      setShowEditModal(false);
    } catch (error) {
      setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      console.error('Error creating Status:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  


  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      setLoadingText('Daten werden erstellt, bitte warten...');
      setLoading(true);
      formData.rec_date = new Date();
      const recDate = formData.rec_date;
      const validDate = isValidDate(recDate) ? recDate : null;     
      formData.rec_date = validDate;
      await UserService.createStatusBoard(formData);
      setDeleteState(prev => !prev);
      setShowCreateModal(false);
      
    } catch (error) {
      setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      console.error('Error creating Area Group:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleBlur = () => {
    validateForm();
 };

 const handleChange = (e) => {
   setFormData({
     ...formData,
     [e.target.name]: e.target.value
   });
 validateForm();
 };

 const handleCloseModal = () => setShowModal(false);
  


  return (
    <Container>
      <h1 className="mt-5">Statusübersicht</h1>
                {/* Display error if it exists */}
         {/* Display error if it exists */}
         <ErrorModal show={showModal} handleClose={handleCloseModal} errorCode={errorCode} errorMessage={apierrors} />
      <Button variant="info" onClick={handleCreateClick} className="mr-2 mb-2">
        Erstellen
      </Button>
      {loading && (
        <div className="spinner-overlay">
         <div className="spinner-background">
          <Spinner animation="border" role="status" className="spinner-border">
            <span className="sr-only">Lade...</span>
          </Spinner>
          <div className="spinner-text">...{loadingText}</div>
          </div>
        </div>
      )}
      {/* Filter Input */}
      <Form.Group controlId="formBasicSearch">
        <Form.Control
          type="text"
          placeholder="Suche nach Statusname, ID und Datum"
          value={filterTerm}
          onChange={(e) => setFilterTerm(e.target.value)}
        />
      </Form.Group>
      {/* Table */}
      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            {/* Sortable column headers */}
            <th onClick={() => handleSort('status_id')} style={{ cursor: 'pointer' }}>
              ID {sortConfig.key === 'status_id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('status_name')} style={{ cursor: 'pointer' }}>
              Statusname {sortConfig.key === 'status_name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('rec_date')} style={{ cursor: 'pointer' }}>
              Erstelldatum {sortConfig.key === 'rec_date' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {sortedMainVOs.map((vo) => (
            <tr key={vo.status_id}>
              <td>{vo.status_id}</td>
              <td>{vo.status_name}</td>
              <td style={{ whiteSpace: 'nowrap' }}>{vo.rec_date}</td>
              <td>
                <ButtonGroup>
                  <Button variant="warning" onClick={() => handleEditClick(vo)} className="mr-2" title="Bearbeiten" aria-label="Bearbeiten">
                    <FaEdit />
                  </Button>
                  <Button variant="danger" onClick={(e) => handleDeleteClick(vo.status_id,e)} title="Löschen" aria-label="Löschen">
                    <FaTrash />
                  </Button>
                </ButtonGroup>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination>
        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />

        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item
            key={index}
            active={index + 1 === currentPage}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}

        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>
      {/* Create Modal */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Statusobjekt erstellen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCreateSubmit}>
            <Form.Group controlId="formAreaGroupName">
              <Form.Label>Statusname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Statusnamen eingeben"
                name="status_name"
                value={formData.status_name}
                onChange={handleChange}
                isInvalid={!!errors.status_name}
                onBlur={handleBlur}
              />
              <Form.Control.Feedback type="invalid">
                {errors.status_name}
              </Form.Control.Feedback>
            </Form.Group>

           

            <Button variant="primary" type="submit" className="mt-3" disabled={loading}>
             {loading ? 'Wird gespeichert...' : 'Statusobjekt speichern'}
              
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Statusobjekt bearbeiten</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEditSubmit}>
          <Form.Group controlId="formAreaGroupName">
              <Form.Label>Statusname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Statusnamen eingeben"
                name="status_name"
                value={formData.status_name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.status_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.status_name}
              </Form.Control.Feedback>
            </Form.Group>


            
            

            <Button variant="primary" type="submit" className="mt-3"disabled={loading}>
            {loading ? 'Wird aktualisiert...' : 'Statusobjekt aktualisieren'}
            
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default BoardStatus;